import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { rem } from '@utils';

const pulse = keyframes`
  0%, 100% {
    transform: scale(0.75);
    opacity: 0.4;
  }

  50% {
    transform: scale(1.5);
    opacity: 1;
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${rem(6)};
`;

const Dot = styled.div(
  ({ theme }) => css`
  animation: ${pulse} 1.2s ease-in-out infinite backwards;
  background: ${theme.palette.primary.main};
  border-radius: 50%;
  will-change: transform, opacity;
  height: ${rem(6)};
  width: ${rem(6)};

  &:nth-of-type(2) {
    animation-delay: 0.2s;
  }

  &:nth-of-type(3) {
    animation-delay: 0.4s;
  }
`
);

export default {
  Wrapper,
  Dot
};
